import { Injectable } from '@angular/core';
import {SearchParam} from "../../defines/client.const";

@Injectable({
  providedIn: 'root'
})
export class LastIdService {

  constructor() { }

  /******************************************************************************
   * Word
   *****************************************************************************/

  private lastDetailWordId: string | null = null;
  private lastListWordId: string | null = null;

  public setLastWordId(detail_id: string | null, list_id: string | null): void {
    // console.warn('setLastWordId', detail_id, list_id)
    this.lastDetailWordId = detail_id;
    this.lastListWordId = list_id;
  }

  public getLastWordId(): [string | null, string | null] {
    // console.warn('getLastWordId', this.lastDetailWordId, this.lastListWordId)
    return [this.lastDetailWordId, this.lastListWordId];
  }

  public clearLastWordId(): void {
    this.lastDetailWordId = null;
    this.lastListWordId = null;
  }

  /******************************************************************************
   * Homonym
   *****************************************************************************/

  private lastDetailHomonymId: string | null = null;
  private lastListHomonymId: string | null = null;

  public setLastHomonymId(detail_id: string | null, list_id: string | null): void {
    // console.warn('setLastHomonymId', detail_id, list_id)
    this.lastDetailHomonymId = detail_id;
    this.lastListHomonymId = list_id;
  }

  public getLastHomonymId(): [string | null, string | null] {
    // console.warn('getLastHomonymId', this.lastDetailHomonymId, this.lastListHomonymId)
    return [this.lastDetailHomonymId, this.lastListHomonymId];
  }

  public clearLastHomonymId(): void {
    this.lastDetailHomonymId = null;
    this.lastListHomonymId = null;
  }

  /******************************************************************************
   * Sajaseungeo
   *****************************************************************************/

  private lastDetailSajaseungeoId: string | null = null;
  private lastListSajaseungeoId: string | null = null;

  public setLastSajaseungeoId(detail_id: string | null, list_id: string | null): void {
    // console.warn('setLastSajaseungeoId', detail_id, list_id)
    this.lastDetailSajaseungeoId = detail_id;
    this.lastListSajaseungeoId = list_id;
  }

  public getLastSajaseungeoId(): [string | null, string | null] {
    // console.warn('getLastSajaseungeoId', this.lastDetailSajaseungeoId, this.lastListSajaseungeoId)
    return [this.lastDetailSajaseungeoId, this.lastListSajaseungeoId];
  }

  public clearLastSajaseungeoId(): void {
    this.lastDetailSajaseungeoId = null;
    this.lastListSajaseungeoId = null;
  }

  /******************************************************************************
   * Example
   *****************************************************************************/

  private lastDetailExampleId: string | null = null;
  private lastListExampleId: string | null = null;

  public setLastExampleId(detail_id: string | null, list_id: string | null): void {
    this.lastDetailExampleId = detail_id;
    this.lastListExampleId = list_id;
  }

  public getLastExampleId(): [string | null, string | null] {
    return [this.lastDetailExampleId, this.lastListExampleId];
  }

  public clearLastExampleId(): void {
    this.lastDetailExampleId = null;
    this.lastListExampleId = null;
  }

}
